module.exports = __webpack_public_path__ + "static/media/scotland.db814740.svg";